import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { getVipRewards, deleteVipReward } from "../../store/vipReward/action";
import { OPEN_DIALOGUE_VIP_REWARD } from "../../store/vipReward/type";
// import AdmissionCarDialogue from "../dialog/AdmissionCarDialogue";
import { baseURL } from "../../util/Config";
import { permissionError, warning } from "../../util/Alert";
import noImage from "../../assets/images/noImage.png";
import VipRewardDialog from "../dialog/VipRewardDialog";

const VipRewards = (props) => {
  const { vipRewards } = useSelector((state) => state.vipReward);
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const [data, setData] = useState([]);

  useEffect(() => {
    props.getVipRewards();
  }, []);

  useEffect(() => {
    setData(vipRewards);
    console.log(vipRewards);
  }, [vipRewards]);

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase()
      ? e.target.value.trim().toUpperCase()
      : e.target.value.trim();
    if (value) {
      const data = vipRewards.filter((data) => {
        return (
          data?.diamond?.toString()?.indexOf(value) > -1 ||
          data?.name?.toUpperCase()?.indexOf(value) > -1
        );
      });
      setData(data);
    } else {
      return setData(vipRewards);
    }
  };

  const dispatch = useDispatch();

  const handleOpen = () => {
    dispatch({ type: OPEN_DIALOGUE_VIP_REWARD });
  };

  const handleEdit = (data) => {
    dispatch({ type: OPEN_DIALOGUE_VIP_REWARD, payload: data });
  };

  const handleDelete = (id) => {
    console.log("hasPermission", hasPermission);
    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          if (!hasPermission) return permissionError();
          props.deleteVipReward(id);
          alert("Deleted!", `Vip reward has been deleted!`, "success");
        }
      })
      .catch((err) => console.log(err));
  };

  // set default image

  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", `${baseURL}storage/male.png`);
    });
  });

  const getImagePreview = (data) => {
    if (data?.type === "avatarFrame") {
      return data?.avatarFrame?.imagePreview
        ? data?.avatarFrame?.imagePreview
        : data?.avatarFrame?.image;
    } else if (data?.type === "background") {
      return data?.background?.image;
    } else if (data?.type === "entranceEffect") {
      return data?.entranceEffect?.imagePreview;
    } else {
      return null;
    }
  };

  const getName = (data) => {
    if (data?.type === "avatarFrame") {
      return data?.avatarFrame?.name;
    } else if (data?.type === "background") {
      return data?.background?.name;
    } else if (data?.type === "entranceEffect") {
      return data?.entranceEffect?.name;
    } else {
      return null;
    }
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">VIP Rewards</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>

                <li className="breadcrumb-item active" aria-current="page">
                  VIP Rewards
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="main-wrapper">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left">
            <button
              type="button"
              className="btn waves-effect waves-light btn-danger btn-sm float-left"
              id="bannerDialog"
              onClick={handleOpen}
            >
              <i className="fa fa-plus"></i>
              <span className="icon_margin">New</span>
            </button>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right mt-3 mb-3 mt-lg-0 mt-xl-0">
            <form action="">
              <div className="input-group mb-3 border rounded-pill">
                <div className="input-group-prepend border-0">
                  <div id="button-addon4" className="btn text-danger">
                    <i className="fas fa-search mt-2"></i>
                  </div>
                </div>
                <input
                  type="search"
                  placeholder="What're you searching for?"
                  aria-describedby="button-addon4"
                  className="form-control bg-none border-0 rounded-pill searchBar"
                  style={{ background: "#181821" }}
                  onChange={handleSearch}
                />
              </div>
            </form>
          </div>
        </div>
        <div className="row">
          {data?.length > 0 ? (
            data.map((data, index) => {
              return (
                <>
                  <div
                    className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4"
                    key={index}
                  >
                    <div className="card contact-card card-bg">
                      <div className="card-body p-1">
                        <div className="px-3 py-4">
                          <div
                            className="col-4"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "flex-end",
                            }}
                          >
                            <img
                              src={
                                getImagePreview(data)
                                  ? getImagePreview(data)
                                  : noImage
                              }
                              style={{
                                width: "135px",
                                height: "135px",
                                objectFit: "cover",
                              }}
                              alt=""
                              height={80}
                            />
                          </div>

                          <div
                            className="pe-4"
                            style={{
                              padding: 0,
                              paddingLeft: 5,
                            }}
                          >
                            <div className="px-3">
                              <div className="mt-2">
                                <h5 className="text-white">
                                  Type: {data?.type}
                                </h5>
                              </div>
                              <div className="mt-2">
                                <h5 className="text-white">
                                  Name: {getName(data)}
                                </h5>
                              </div>

                              <div className="mt-2">
                                <h5 className="text-white">ID: {data?._id}</h5>
                              </div>

                              <div className="mt-2">
                                <h5 className="text-white">
                                  Validity:{" "}
                                  {data?.validity + " " + data?.validityType}
                                </h5>
                              </div>
                            </div>

                            <div className="px-3">
                              <i
                                className="fas fa-edit text-white p-2 bg-primary rounded-circle"
                                style={{ marginRight: 10, fontSize: 25 }}
                                onClick={() => handleEdit(data)}
                              ></i>

                              <i
                                className="fas fa-trash text-white p-2 bg-danger rounded-circle"
                                style={{ marginRight: 10, fontSize: 25 }}
                                onClick={() => handleDelete(data?._id)}
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <tr>
              <td colSpan="6" align="center">
                Nothing to show!!
              </td>
            </tr>
          )}
        </div>
      </div>
      <VipRewardDialog />
    </>
  );
};

export default connect(null, { getVipRewards, deleteVipReward })(VipRewards);
